<template>
	<div class="patient_relation">
		<div class="module-title">请选择您与患者的关系</div>
		<div class="patient_relation_body">
			<van-button
				v-for="(item, index) in list"
				:key="index"
				class="btn"
				:class="{ 'btn-primary': $status.relation[modelValue] === item }"
				@click="clickItem(item)"
			>
				{{ item }}
			</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'patient-relation',
		props: {
			value: {
				type: [String, Number],
				default: ''
			}
		},
		data: () => ({
			list: ['本人', '子女', '家属', '其他']
		}),
		computed: {
			modelValue: {
				get () {
					return this.value
				},
				set (val) {
					this.$emit('input', val)
				}
			}
		},
		methods: {
			clickItem (item) {
				const val = Object.entries(this.$status.relation).find(v => v[1] === item)
				this.modelValue = val[0]
			}
		}
	};
</script>

<style scoped lang="less">
	.patient_relation {
		.patient_relation_body {
			margin-top: 40px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			&>.btn{
				width: 136px;
				height: 72px;
				line-height: 72px;
				border-radius: 10px;
				box-sizing: border-box;
				border: 2px solid #DEE0E3;
				transition: all .2s;
				&.btn-primary {
					border-color: @primary;
					background-color: @primary;
					color: #fff;
				}
			}
		}
	}
</style>
